import React from "react";

const CATEGORY_COLORS = {
  Transport:       { bg: "bg-[#FFE9B0]", text: "text-[#5C3D00]" },
  Mediu:           { bg: "bg-[#A7F3D0]", text: "text-[#073B27]" },
  Educație:        { bg: "bg-[#D7DDFF]", text: "text-[#1E2A78]" },
  Sănătate:        { bg: "bg-[#FFD0CE]", text: "text-[#7A1A14]" },
  Infrastructură:  { bg: "bg-[#E1E7E4]", text: "text-[#1F2A24]" },
  Digitalizare:    { bg: "bg-[#0A4D34]", text: "text-white" },
};

export default function CategoryBadge({ category, className = "" }) {
  const c = CATEGORY_COLORS[category] ?? CATEGORY_COLORS.Infrastructură;
  return (
    <span
      className={`inline-flex items-center text-[11px] uppercase tracking-[0.18em] font-semibold px-2.5 py-1 rounded-sm ${c.bg} ${c.text} ${className}`}
    >
      {category}
    </span>
  );
}
